import { AuthGuard } from "@ssf/auth-components";
import { Loading, useTrackPageChange } from "@ssf/components";
import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router";

import { routes } from "../lib/index.js";

const TournamentsPage = lazy(() => import("../pages/TournamentsPage.jsx"));
const MyPage = lazy(() => import("../pages/MyPage.jsx"));
const RegPage = lazy(() => import("../pages/RegPage.jsx"));
const TournamentPage = lazy(() => import("../pages/TournamentPage.jsx"));
const MyTournamentPage = lazy(() => import("../pages/MyTournamentPage.js"));
const RegTeamPage = lazy(() => import("../pages/RegTeamPage.jsx"));
const TeamPage = lazy(() => import("../pages/TeamPage.jsx"));
const CreateClubPage = lazy(() => import("../pages/CreateClubPage.jsx"));
const AddMemberPage = lazy(() => import("../pages/AddMemberPage.jsx"));

export const Router = () => {
  useTrackPageChange();

  return (
    <Routes>
      <Route
        path={routes.tournaments}
        element={
          <Suspense fallback={<Loading />}>
            <TournamentsPage />
          </Suspense>
        }
      />
      <Route
        path={routes.myPage}
        element={
          <Suspense fallback={<Loading />}>
            <MyPage />
          </Suspense>
        }
      />
      <Route
        path={routes.reg}
        element={
          <Suspense fallback={<Loading />}>
            <RegPage />
          </Suspense>
        }
      />
      {[routes.tournament, routes.tournamentGroup].map((path) => (
        <Route
          key={path}
          path={path}
          element={
            <Suspense fallback={<Loading />}>
              <TournamentPage />
            </Suspense>
          }
        />
      ))}
      <Route
        path={routes.myTournamentPage}
        element={
          <Suspense fallback={<Loading />}>
            <AuthGuard>
              <MyTournamentPage />
            </AuthGuard>
          </Suspense>
        }
      />
      <Route
        path={routes.regTeam}
        element={
          <Suspense fallback={<Loading />}>
            <AuthGuard>
              <RegTeamPage />
            </AuthGuard>
          </Suspense>
        }
      />
      <Route
        path={routes.team}
        element={
          <Suspense fallback={<Loading />}>
            <TeamPage />
          </Suspense>
        }
      />
      <Route
        path={routes.createClub}
        element={
          <Suspense fallback={<Loading />}>
            <AuthGuard>
              <CreateClubPage />
            </AuthGuard>
          </Suspense>
        }
      />
      <Route
        path={routes.addPlayer}
        element={
          <Suspense fallback={<Loading />}>
            <AuthGuard>
              <AddMemberPage type="player" />
            </AuthGuard>
          </Suspense>
        }
      />
      <Route
        path={routes.addTeamLeader}
        element={
          <Suspense fallback={<Loading />}>
            <AuthGuard>
              <AddMemberPage type="teamLeader" />
            </AuthGuard>
          </Suspense>
        }
      />
    </Routes>
  );
};
